import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import API from '../api';
import notify from '../components/Notification/helper';
import { useGetShortCode } from "./useGetShortCode";
import { setShortCode } from "../utils/gamification";
import { useUpdatePageViewsCount } from "./useUpdatePageViewsCount";

export const useLogPageView = retailerId => {
    if (!retailerId) return;

    let shortCode = useGetShortCode();
    const location = useLocation();
    const gelocation = useSelector(state => state.geolocation);

    useUpdatePageViewsCount();
    
    useEffect(async () => {
        if (!shortCode) {
            shortCode = await API.getShortCode();
            setShortCode(shortCode);
        }
        
        try {
            // build log payload
            const pageViewPayload = {
                user_agent: navigator.userAgent?.substring(0, 255),
                url: `${location.pathname}${location?.search || ''}`,
                retailer: retailerId,
                ip: gelocation.ip,
                country: gelocation?.country_code,
                region: gelocation?.region_code,
                short_codes: shortCode,
            }
            
            // post page view log
            await API.postLoadPageViewAnalytics(pageViewPayload)
        } catch (error) {
            error.map((err) => notify('error', err.message));
        } finally {}
    }, []);
}